import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import axios from "axios";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { connect } from "react-redux";
import { store } from "../../_store";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import { EmptyRecord } from "../../utils/PageUtility";
import CircularProgress from "../../utils/CircularProgress";
import SearchIcon from "@material-ui/icons/Search";
import AccordionItem from "./faq-accordion";
import {
  Grid,
  TextField,
  InputAdornment,
  FormGroup,
  Modal,
  ModalHeader,
  CardContent,
  Typography,
  Dialog,
DialogTitle,
DialogContent
} from "@material-ui/core";
import DetailedItem from "./nested-accordion";
// import { FaComment, FaEnvelope, FaPhone, FaWhatsapp } from "react-icons/fa";
import CardDetails from "./card-details";
import DismissIcon from "@material-ui/icons/Close";
import CallIcon from '@material-ui/icons/Call';
import EmailIcon from '@material-ui/icons/EmailOutlined';
import WhatsAppIcon from '@material-ui/icons/ChatBubble';
import ChatBubbleOutlineIcon from '@material-ui/icons/CommentOutlined';

let source;

class HelpCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //     totalCount: 0,
      modalOpen: false,
      details: null,
      selectedIndex: 0,
      records: null,
      currentPage: 1,
      pageSize: 10,
      searchParams: [],
      pageRequesting: true,
    };
    source = axios.CancelToken.source();
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    let { users } = store.getState();
    const { dispatch } = this.props;
    if (users) {
      users = this.packageUsers(users.ResultList);
      this.setState({ users });
    } else {
      dispatch(commonActions.getAllUsers());
    }

    this.getFaq();
  }

  componentWillReceiveProps = function(nextProps) {
    let { users } = nextProps;
    if (users) {
      users = this.packageUsers(users.ResultList);
      this.setState({ users });
    }
  };

  packageUsers = (users) => {
    let data = [];
    users.map((item) =>
      data.push({
        ...item,
        type: "USR",
        label: `${item.FirstName} ${item.LastName}`,
        value: item.Id,
      })
    );
    return data;
  };

  findUser = (userId) => {
    const { users } = this.state;
    const check = users.find((item) => item.Id === userId);
    return check ? `${check.FirstName} ${check.LastName}` : "Unknown User";
  };

  getFaq = (pageNumber = 0) => {
    const { dispatch } = this.props;
    const { pageSize, search } = this.state;

    let payload = {
      pageSize: pageSize,
      pageNumber: pageNumber,
      parameter: {
        // query: search,
        productName: "PSC REGIONAL",
        status: 3,
      },
    };
    dispatch(alertActions.startRequest());
    commonService.searchFaq(payload, source.token).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.setState({
          totalCount: response.data.count,
          records: response.data.object,
          pageRequesting: false,
          //   dataContent: response.data.object[0].content,
          //   currentPage: pageNumber === 0 ? 1 : pageNumber,
        });
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        this.setState({ pageRequesting: false });
      }
    });
  };
  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }));
  };

  generateAccordionData = () => {
    const { filteredRecords, records } = this.state;
    const data = filteredRecords || records;

    return data.reduce((acc, record) => {
      const existingCategory = acc.find(
        (item) => item.categoryName === record.categoryName
      );
      console.log(existingCategory, "cat");
      if (existingCategory) {
        const titleLines = record.title.split("\n");
        existingCategory.titles.push(...titleLines);
        const contentLines = record.content.split("\n"); // Split content into lines
        existingCategory.content.push(...contentLines); // Push content lines
      } else {
        acc.push({
          categoryName: record.categoryName,
          titles: record.title.split("\n"),
          content: record.content.split("\n"), // Split content into lines
        });
      }
      return acc;
    }, []);
  };

  handleSearchInputChange = (event) => {
    const { value } = event.target;
    const { records } = this.state;

    // Filter records based on the search input
    const filteredRecords = records.filter((record) =>
      record.title.toLowerCase().includes(value.toLowerCase())
    );

    this.setState({
      searchInput: value,
      filteredRecords,
    });
    console.log(filteredRecords, "rec");
  };

  showDetails = (details) => {
    this.setState({
      details: {
        firstContent: details.firstContent,
        subContent: details.subContent,
      },
    });
    console.log(details, "who");
  };

  handleIndexSelected = (index) => {
    this.setState({
      selectedIndex: index,
    });
  };

  openWhatsAppChat = () => {
    window.open("https://wa.me/+2347046270754", "_blank");
  };

  callPhoneNumber = () => {
    window.open("tel:+2347046270753");
  };

  sendEmail = () => {
    window.location.href = "mailto:support@avitech.ng";
  };

  openLiveChat = () => {
    if (typeof Tawk_API !== "undefined") {
      // Tawk_API.toggle();
    }
  };

  componentWillUnmount() {
    if (source) {
      source.cancel();
    }
  }

  render() {
    const {
      pageRequesting,
      audits,
      totalCount,
      currentPage,
      pageSize,
      StartDate,
      EndDate,
      searchParams,
      filterModes,
      selectedFilterMode,
      records,
      details,
      selectedIndex,
      searchInput,
    } = this.state;
    const { user } = this.props;

    if (pageRequesting) return <CircularProgress />;

    return (
      <div>
        <Grid container>
          <Grid item md={6}>
            <p variant="body1">
              Hi <strong>{user.fullName.split(" ")[0]}</strong>, How can we help
              you?
            </p>
          </Grid>
        </Grid>
        <GridContainer>
          <GridItem xs={12} md={6}>
            <FormGroup>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextField
                  type="text"
                  name="search"
                  onChange={this.handleSearchInputChange}
                  id="search"
                  value={searchInput}
                  variant="outlined"
                  placeholder="Search"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </FormGroup>
          </GridItem>

          <Card>
            <CardBody>
              {!pageRequesting &&
                totalCount !== 0 && (
                  <div>
                    <GridItem xs={12} md={12}>
                      <p style={{ fontSize: "17px", whiteSpace: "nowrap", marginBottom: "12px",}}>
                        Faq Categories
                      </p>
                    </GridItem>
                    <GridContainer
                      xs={12}
                      md={12}
                      style={{ marginRight: "32%" }}
                    >
                      <GridItem md={4}>
                        {this.generateAccordionData().map(
                          (groupedData, index) => (
                            <AccordionItem
                              key={index}
                              title={groupedData.categoryName}
                              showDetails={this.showDetails}
                              subContent={groupedData.content}
                              firstContent={groupedData.titles}
                              handleSelectedIndex={this.handleIndexSelected.bind(
                                this
                              )}
                            />
                          )
                        )}
                      </GridItem>
                      <GridItem md={8} className="detailed-item-col">
                        {/* DetailedItem */}
                        {details && (
                          <DetailedItem
                            contentTitle={details.firstContent}
                            subContent={details.subContent}
                            selectedIndex={selectedIndex}
                          />
                        )}
                      </GridItem>
                    </GridContainer>
                  </div>
                )}

              {!pageRequesting &&
                totalCount === 0 && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <EmptyRecord message={"No record found"} />
                    </GridItem>
                  </GridContainer>
                )}
            </CardBody>
          </Card>
          {/* 
          <Modal isOpen={this.state.modalOpen} toggle={this.toggleModal}>
            <ModalHeader toggle={this.toggleModal} />
            <ModalBody>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <CardDetails
                    icon={<FaComment size="15" />}
                    item1="Live Chat"
                    item2="chat with a representative"
                    item3="click here"
                    onClickItem={this.openLiveChat}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CardDetails
                    icon={<FaEnvelope size="15" />}
                    item1="Email us"
                    item2="We'll reply in one business day"
                    item3="support@avitech.ng"
                    onClickItem={this.sendEmail}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CardDetails
                    icon={<FaPhone size="15" />}
                    item1="call us"
                    item2="speak with a representative"
                    item3="+234 704 627 0753"
                    onClickItem={this.callPhoneNumber}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CardDetails
                    icon={<FaWhatsapp size="15" />}
                    item1="whatsApp"
                    item2="chat with a representative"
                    item3="+234 704 627 0754"
                    onClickItem={this.openWhatsAppChat}
                  />
                </Grid>
              </Grid>
            </ModalBody>
          </Modal> */}
          <Dialog
            fullWidth={true}
            maxWidth={"sm"}
            open={this.state.modalOpen}
            onClose={() => {}}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle
              id="responsive-dialog-title"
              style={{ color: `${appConstants.REGIONAL_COLOR}` }}
            >
              <div style={{ float: "left" }}>
                <span style={{ color: `${appConstants.REGIONAL_COLOR}` }}>
                  Talk to Support
                </span>
              </div>
              <div style={{ float: "right" }}>
                <span onClick={this.toggleModal}>
                  <DismissIcon
                    style={{
                      cursor: "pointer",
                      fontSize: "30px",
                      color: `${appConstants.REGIONAL_COLOR}`,
                    }}
                  />
                </span>
              </div>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={6}>
                <GridItem xs={12} md={6}>
                  <CardDetails
                    icon={<ChatBubbleOutlineIcon size="12" />}
                    item1="Live Chat"
                    item2="chat with a representative with our chat box on your screen"
                    // item3="click here"
                    onClickItem={this.openLiveChat}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CardDetails
                    icon={<EmailIcon size="12" />}
                    item1="Email us"
                    item2="We'll reply in one business day"
                    item3="support@avitech.ng"
                    onClickItem={this.sendEmail}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CardDetails
                    icon={<CallIcon size="12" />}
                    item1="call us"
                    item2="speak with a representative"
                    item3="+234 704 627 0753"
                    onClickItem={this.callPhoneNumber}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CardDetails
                    icon={<WhatsAppIcon size="12" />}
                    item1="whatsApp"
                    item2="chat with a representative"
                    item3="+234 704 627 0754"
                    onClickItem={this.openWhatsAppChat}
                  />
                </GridItem>
              </Grid>
            </DialogContent>
          </Dialog>

          <div style={{ marginTop: "10%" }}>
            <Grid container justify="flex-end">
            <GridItem xs={12} sm={12} md={12}>
                <Typography variant="body1" className="help-text">
                  Need more help?
                </Typography>
              </GridItem>
            </Grid>
            <Grid container justify="flex-end">
            <GridItem xs={12} sm={12} md={12}>
                <Typography
                  variant="body1"
                  className="support-modal"
                  onClick={this.toggleModal}
                >
                  Talk to support
                </Typography>
              </GridItem>
            </Grid>
          </div>
        </GridContainer>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { alert, requesting, users, user } = state;
  return {
    alert,
    requesting,
    users,
    user,
  };
}

export default connect(mapStateToProps)(
  withMobileDialog()(withStyles(dashboardStyle)(HelpCenter))
);



// WEBPACK FOOTER //
// ./src/Regional-Views/HelpCenter/index.js